var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 2.75C11.8695 2.75 3.25 11.3695 3.25 22C3.25 32.6305 11.8695 41.25 22.5 41.25C33.1305 41.25 41.75 32.6305 41.75 22C41.75 11.3695 33.1305 2.75 22.5 2.75ZM28.6918 22.2965L19.3074 29.1242C19.256 29.1612 19.1953 29.1833 19.1322 29.188C19.069 29.1928 19.0057 29.18 18.9493 29.1511C18.8929 29.1223 18.8456 29.0784 18.8125 29.0244C18.7794 28.9704 18.7618 28.9083 18.7617 28.8449V15.198C18.7615 15.1346 18.7789 15.0723 18.8119 15.0181C18.8449 14.9638 18.8923 14.9198 18.9489 14.8909C19.0054 14.862 19.0688 14.8493 19.1321 14.8542C19.1954 14.8591 19.2561 14.8815 19.3074 14.9187L28.6918 21.7422C28.7361 21.7735 28.7723 21.8151 28.7973 21.8633C28.8222 21.9115 28.8352 21.965 28.8352 22.0193C28.8352 22.0736 28.8222 22.1271 28.7973 22.1754C28.7723 22.2236 28.7361 22.2651 28.6918 22.2965Z",
    fill: "#01D676"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/play-icon.3c7e5b04a59398d10bd50d582c5a8fe8.svg";
export { ForwardRef as ReactComponent };